// @flow

import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import { createdAtField, getCreatedAtSort, idField } from '../abstract/StoredEntity';
import type { StoredEntity } from '../abstract/StoredEntity';
import { constructEndpoints } from '../helpers';

class PhoneCheck implements StoredEntity {
    static classInternalName = 'phone_check';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        ref: {
            displayName: 'Reference',
            recordName: 'ref',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: undefined,
            isOptional: false,
            displayOnMain: true,
        },
        phone: {
            displayName: 'Phone',
            recordName: 'phone',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: false,
            needToCreate: undefined,
            canEdit: undefined,
            isOptional: false,
            displayOnMain: true,
        },
        verified: {
            displayName: 'Verified',
            recordName: 'verified',
            dataType: {
                primitive: 'bool',
                isArray: false,
                extraData: null,
            },
            supportsQuery: true,
            supportsSort: true,
            needToCreate: undefined,
            canEdit: undefined,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = getCreatedAtSort('created_at');

    get id() {
        return this.record[PhoneCheck.fields.id.recordName];
    }

    get displayName() {
        return `${this.record[PhoneCheck.fields.phone.recordName]}: Verified 
                ${this.record[PhoneCheck.fields.verified.recordName]}`;
    }

    static endpoints: Endpoints = constructEndpoints('phone-checks');

    constructor(record: any) {
        this.record = record;
    }
}

export default PhoneCheck;
